import {
    CREATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK,
    CREATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK,
    CREATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK,
    DELETE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK,
    DELETE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK,
    DELETE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_REQUEST_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_FAILURE_DK,
    UPDATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK,
    UPDATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK,
    UPDATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK,
    RESET_IRONING_PACKING_INWARD_MASTER_INFO_DK,
    CREATE_IRONING_PACKING_INWARD_MASTER_FORM_DK,
    UPDATE_IRONING_PACKING_INWARD_MASTER_FORM_DK,
    NAVIGATE_IRONING_PACKING_INWARD_DETAILS_DK,
    NAVIGATE_IRONING_PACKING_INWARD_MASTER_DK,
    FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_IRONING_PACKING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK,
    CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_FAILURE_DK,
    SET_PENDING_GRID_NAME_IRONING_PACKING_INWARD_DK,
    SET_UNIT_NAME_IRONING_PACKING_INWARD_DK,
    FETCH_COMPLETE_IRONING_PACKING_INWARD_REQUEST_DK,
    FETCH_COMPLETE_IRONING_PACKING_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_IRONING_PACKING_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './ironingPackingInwardHeader.actionsType';

export const IRONING_PACKING_INWARD_DK_MASTER = 'ironingPackingInwardDKHeader';

let initialState = {
    loading: false,
    ironingPackingInwardHeader: [],
    ironingPackingInwardHeaderEditQuantity: [],
    pendingIroningPackingDc: [],
    activeKey: 1,
    ironingPackingInwardId: '',
    detailsId: [],
    completeironingPacking:[],
    reportSingleIroningPackingProgramInwardList:[],
    styleData: {},
    ironingPackingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierDCValue: null,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldDiscountPercentage: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleIroningPackingInwardData: {},
    isIroningPackingInwardDetails: false,
    renderGridBtn: 'pendingGrid',
    unitId: '',
};

export let ironingPackingInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_IRONING_PACKING_INWARD_MASTER_REQUEST_DK:
        case FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK:
        case CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_REQUEST_DK:
        case UPDATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK:
        case DELETE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK:
        case FETCH_COMPLETE_IRONING_PACKING_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeader: updatePayload
            };
        case FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderEditQuantity: updatePayload?.CUD,
                activeKey: 2
            };
        case FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingIroningPackingDc: updatePayload
            };
        case CREATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                ironingPackingInwardId: payload[0]?.fldID,
                detailsId: payload,
                activeKey: 2
            };
            case FETCH_COMPLETE_IRONING_PACKING_INWARD_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    completeironingPacking: updatePayload
                };
                case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
                    return {
                        ...state,
                        loading: false,
                        reportSingleIroningPackingProgramInwardList: updatePayload
                    };
        case CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                activeKey: 1,
                detailsId: []
            };
        case UPDATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_IRONING_PACKING_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                // ironingPackingInwardId: '',
                styleData: {},
                activeKey: 1
            };
        case CREATE_IRONING_PACKING_INWARD_MASTER_FORM_DK:
        case UPDATE_IRONING_PACKING_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderForm: {
                    ...state.ironingPackingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_IRONING_PACKING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: 1
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK:
            return {
                ...state,
                loading: false,
                ironingPackingInwardHeaderEditQuantity: [],
                detailsId: []
            };
        case FETCH_IRONING_PACKING_INWARD_MASTER_FAILURE_DK:
        case FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK:
        case CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK:
        case DELETE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK:
        case FETCH_COMPLETE_IRONING_PACKING_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK:
            return {
                ...state,
                ironingPackingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedTeam: {}
            };
            case SET_PENDING_GRID_NAME_IRONING_PACKING_INWARD_DK:
                return {
                    ...state,
                    renderGridBtn: payload
                };
            case SET_UNIT_NAME_IRONING_PACKING_INWARD_DK:
                return {
                    ...state,
                    unitId: payload
                };
        case NAVIGATE_IRONING_PACKING_INWARD_DETAILS_DK:
            return {
                ...state,
                isIroningPackingInwardDetails: true,
                singleIroningPackingInwardData: updatePayload.singleIroningPackingInwardData
            };
        case NAVIGATE_IRONING_PACKING_INWARD_MASTER_DK:
            return {
                ...state,
                isIroningPackingInwardDetails: false
            };
        default:
            return state;
    }
};
